import script from "./ContentLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentLoader.vue?vue&type=script&setup=true&lang=js"

import "./ContentLoader.vue?vue&type=style&index=0&id=1f5feba9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f5feba9"]])

export default __exports__